export const uxDesignerSecuritySetup = {
  junior: {
    requirements: [
      'Enable 2FA on all design tools',
      'Set up company VPN access',
      'Configure secure file sharing',
      'Password manager setup',
      'Basic security training completion'
    ],
    procedures: [
      'Daily security checklist',
      'Secure design file handling',
      'Safe external sharing practices',
      'Incident reporting process'
    ]
  },
  mid: {
    requirements: [
      'Advanced 2FA setup',
      'Security key configuration',
      'Secure client communication',
      'Advanced privacy settings',
      'Security audit participation'
    ],
    procedures: [
      'Security review processes',
      'Client data protection',
      'Advanced threat awareness',
      'Security mentoring for juniors'
    ]
  },
  senior: {
    requirements: [
      'Security policy compliance',
      'Team security oversight',
      'Advanced threat protection',
      'Security audit leadership',
      'Compliance certification'
    ],
    procedures: [
      'Security policy development',
      'Team security training',
      'Incident response leadership',
      'Compliance monitoring'
    ]
  }
};
